/* eslint-disable react/require-default-props */
/* eslint-disable import/no-cycle */
import React from 'react';

import ServicesTimeContainer from './components/ServicesTimeContainer';
import { Destination, Version } from '../../../utils/types/ProjectType';

export interface Props {
  dayChecked: string;
  destinations: Destination[];
  detailProjectId: string;
  onLoadVersion: (projectId: string) => void;
  projectName?: string;
  projectType: string;
  typeView: string;
  utcUpadtedAt: string;
  versions: Version[];
}

const InvoiceServiceTimes: React.FC<Props> = function InvoiceServiceTimes({
  detailProjectId,
  projectType,
  typeView,
  dayChecked,
  utcUpadtedAt,
  destinations,
  projectName,
  versions,
  onLoadVersion
}) {
  return (
    <ServicesTimeContainer
      dayChecked={dayChecked}
      destinations={destinations}
      detailProjectId={detailProjectId}
      onLoadVersion={onLoadVersion}
      projectName={projectName}
      projectType={projectType}
      typeView={typeView}
      utcUpadtedAt={utcUpadtedAt}
      versions={versions}
    />
  );
};

export default InvoiceServiceTimes;
